(function () {
  Flint.file("mframework/views/areYouSure.js", function (require) {
    Flint.staticStyles("AreYouSure", {
      "$": "#_flintapp .ViewAreYouSure",
      "$confirming": "#_flintapp confirming.AreYouSure, #_flintapp .AreYouSure.confirming, #_flintapp .ViewAreYouSure.confirming, #_flintapp .AreYouSure > .confirming",
      "$prompt": "#_flintapp prompt.AreYouSure, #_flintapp .AreYouSure.prompt, #_flintapp .ViewAreYouSure.prompt, #_flintapp .AreYouSure > .prompt",
      "$separator": "#_flintapp separator.AreYouSure, #_flintapp .AreYouSure.separator, #_flintapp .ViewAreYouSure.separator, #_flintapp .AreYouSure > .separator"
    }, {
      "$": {},
      "$confirming": {
        flexDirection: 'row',
        alignItems: 'center',
        color: '#999',
        fontSize: 12
      },
      "$prompt": {
        marginRight: 4,
        fontFamily: 'proximanova'
      },
      "$separator": {
        fontSize: 12,
        color: '#999',
        marginLeft: 4,
        marginRight: 4
      }
    });
    Flint.view("AreYouSure", function (view, on, $) {
      var pro = initPro(view, {
        children: atom(),
        prompt: atom()
      });

      var confirming = atom(false);view.render(function () {
        return Flint.iff(!confirming.get()) && view.el(
          ["normal", 1],
          { if: !confirming.get(), onClick: function () {
              return confirming.set(true);
            } },
          pro.children.get()
        );
      });view.render(function () {
        return Flint.iff(confirming.get()) && view.el(
          ["confirming", 1],
          { if: confirming.get() },
          view.el(
            ["prompt", 1],
            null,
            pro.prompt.get() || "Are you sure?"
          ),
          view.el(
            ["LinkButton", 1],
            { className: "yes", onClick: function (e) {
                if (view.props.onClick) {
                  view.props.onClick(e);
                }
                confirming.set(false);
              } },
            "Yes"
          ),
          view.el(
            ["separator", 1],
            null,
            "|"
          ),
          view.el(
            ["LinkButton", 2],
            { className: "no", onClick: function (e) {
                return confirming.set(false);
              } },
            "No"
          )
        );
      });

      "d9a3edb4";
      "a2ff007a";
      "42aa570e";
    });
  })
})();
//# sourceMappingURL=areYouSure.js.map
